//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.07.2015.
 */

(function () {

    'use strict';

    angular.module('container.core')
        .config(configureRoutes);

    function configureRoutes($stateProvider, $urlRouterProvider, $locationProvider) {

        //$locationProvider.html5Mode({enabled: true, requireBase: false});

        $locationProvider.hashPrefix('');

        $urlRouterProvider.when('/', '/dashboard');

        $urlRouterProvider.otherwise('/dashboard');

        $stateProvider
            .state('container', {
                url: '',
                template: '',
                onEnter: function($state, $log, $location) {
                    $log.debug('container route onEnter');
                    $location.path('/');
                }
            })
            .state('dashboard', {
                url: '/dashboard',
                template: '<srsng-dashboard></srsng-dashboard>',
                onEnter: function(initService) {
                    initService.initContainer();
                }
            })
    }

})();
